export const theme = {
  // override default theme
  backgroundColor: `#F5F5F5`,
  textBlack: `#333333`,
  textGrey: `##707070`,
  fontFamily: `Lato`,
  primary: `#FFBF00`,
  secondary: `#B1B1B1`,
  // payment screen
  textGreen: `#02A340`,
  textRed: `#F15A22`,
  // small screen font size(mobile screen)
  smallScreenVerySmall: `10px`,
  smallScreenSmall: `12px`, // (12)
  smallScreenDetails: `14px`, // (13~14)
  smallScreenBodyText: `16px`, // (16~18)
  smallScreenBodyText2: `18px`,
  smallScreenSubTitle: `20px`, // (18~20)
  smallScreenTitle: `24px`, // (24~28)
  smallScreenHeader: `32px`, // (32~38)
  // desktop screen font size
  desktopScreenVerySmall: `12px`,
  desktopScreenSmall: `14px`, // (16)
  desktopScreenDetails: `16px`, // (16~18)
  desktopScreenDetails2: `18px`, // (18)
  desktopScreenBodyText: `20px`, // (20~21)
  desktopScreenSubTitle: `24px`, // (21~24)
  desktopScreenTitle: `34px`, // (34~38)
  desktopScreenHeader: `40px`, // (40~48)
};
